import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, CheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="py-10 sm:py-12 px-4" data-id="element-122">
      <div className="max-w-xl mx-auto" data-id="element-123">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-brand-card border border-brand-gold/30 p-6 sm:p-8 rounded-2xl text-center relative overflow-hidden" data-id="element-124">
          <div className="absolute top-0 right-0 w-32 h-32 bg-brand-gold/10 rounded-full blur-3xl" data-id="element-125" />
          <div className="absolute bottom-0 left-0 w-32 h-32 bg-brand-orange/10 rounded-full blur-3xl" data-id="element-126" />

          <ShieldCheckIcon className="w-14 h-14 text-brand-gold mx-auto mb-4 relative z-10" data-id="element-127" />

          <h3 className="text-2xl sm:text-3xl font-black text-brand-cream mb-3 relative z-10" data-id="element-128">
            SPAREN SIE ODER WIR ERSTATTEN JEDEN RAPPEN
          </h3>

          <p className="text-gray-300 text-sm sm:text-base font-medium leading-relaxed mb-5 relative z-10" data-id="element-129">
            Wir sind so überzeugt von der Wirksamkeit des SWISS PEAK SYSTEMS,
            dass wir Ihnen 7 Tage Zeit geben, es auszuprobieren. Wenn Sie bei
            Ihrem ersten Ausflug nicht mindestens 150 CHF sparen, erstatten wir
            Ihnen jeden Rappen zurück. Ohne Fragen.
          </p>
        </motion.div>
      </div>
    </section>;
}